import { render, staticRenderFns } from "./manageCreatedActi.vue?vue&type=template&id=2faea835&scoped=true"
import script from "./manageCreatedActi.vue?vue&type=script&lang=js"
export * from "./manageCreatedActi.vue?vue&type=script&lang=js"
import style0 from "./manageCreatedActi.vue?vue&type=style&index=0&id=2faea835&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faea835",
  null
  
)

export default component.exports